module.exports = __webpack_public_path__ + "static/media/AirDNA-No-Padding.a565b1f5.svg";